// organize global refetch handles
// example:
//  refetchHandles.pmInterests = props.data.refetch;
//  refetchHandles.pmInterests();
export const refetchHandles = {
  pmInterests: noop, // dashboard where PMs get feed of data
  activityFeed: noop,
};

function noop () {}
